import { endpoints, poster, posterForm, fetcherGET, fetcher, deleter, patcher, fetcherSwr } from '../utils/axios';
import { useMemo } from 'react';
import useSWR from 'swr';
//  Safe fetch with try-catch
// export const getCollection = async (args = {}) => {
//   try {
//     const response = await fetcherGET(`${endpoints.collection.getCollection}`, args);
//     return response;
//   } catch (error) {
//      var response = {};
//      response.status = false;
//      response.message = error?.response?.data?.message??error.message;
//     return response;
//   }
// };


export function useGetCollection(args = {}) {
  const URL = args
    ? [endpoints.collection.getCollection, { params: args }]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      collections: data?.data || [],
      pagination: data?.pagination || {
        total: 0,
        page: args.page || 1,
        limit: args.limit || 10,
        totalPages: 0,
      },
      isLoading,
      collectionError: error,
      collectionValidating: isValidating,
    }),
    [data, error, isLoading, isValidating, args.page, args.limit]
  );

  return memoizedValue;
}


export function useGetCollectionDetails(args = {}) {
  const URL = args?.id
    ? [`${endpoints.collection.getCollectionDetails}/${args.id}`, {}]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);


  const memoizedValue = useMemo(
    () => ({
      collectionDetails: data || {},
      isLoading,
      error,
      isValidating,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}


export const updateCollection = async (id, args = {}) => {
  try {
    const response = await patcher(`${endpoints.collection.updateCollection}${id}`, args);
    return response;
  } catch (error) {
    console.error('updateCollection error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};


export function useGetAssignees(args = {}) {
  const URL = args.centerId
    ? [endpoints.collection.getAssignees + '/' + args.centerId, { params: args }]
    : [endpoints.collection.getAssignees, { params: args }];

  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(() => ({
    assignees: data?.data || [],
    isLoading,
    error,
    isValidating,
  }), [data?.data, error, isLoading, isValidating]);

  return memoizedValue;
}


export function getAssignees(args = {}) {
  return;
}


export function fetchSymptoms(searchText = '') {
  return;
}

export function useGetSymptoms(args = {}) {

  const URL = [endpoints.collection.fetchSymptoms + `?searchText=${encodeURIComponent(args.searchText)}`, {}];
  const { data, error, isLoading, isValidating } = useSWR(URL, fetcherSwr);
  const symptoms = data?.success
    ? data.data.map(item => ({
      label: item?.name ?? '',
      value: item?.name ?? '',
      description: item?.description ?? '',
    }))
    : [];

  return {
    symptoms,
    isLoading,
    isValidating,
    error,
  };
}


export const useFetchPatient = (args = {}) => {
  const id = args?.id;
  // Short-circuit if ID is 0, null, undefined, or invalid
  const isIdValid = !!id && id !== 0;
  const URL = isIdValid ? `${endpoints.collection.getPatient}${id}` : null;

  const { data, error, isValidating } = useSWR(URL, fetcherSwr, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  const isLoading = isIdValid && !data && !error;

  return useMemo(() => ({
    user: data?.data || null,
    isLoading,
    error,
    isValidating,
  }), [data?.data, isLoading, error, isValidating]);
};


export function useGetPatientsList(args = {}) {
  const URL = [endpoints.collection.getPatientsList, { params: args }];

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      patients: data?.data || [],
      pagination: data?.pagination || {
        total: 0,
        page: args.page || 1,
        limit: args.limit || 10,
        totalPages: 0,
      },
      isLoading,
      error,
      isValidating,
    }),
    [data, error, isLoading, isValidating, args.page, args.limit]
  );

  return memoizedValue;
}


export const toggleStarPatient = async (id, starred) => {
  try {
    const url = `${endpoints.collection.toggleStarPatient}${id}/star`;
    const response = await patcher(url, { starred });
    return response;
  } catch (error) {
    console.error('toggleStarPatient error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;
  }
};


export const FetchPatient = async (args = {}) => {

  try {

    // const response = await fetcherGET(`${endpoints.collection.getPatient}${args.id}`,{params:{otp:args?.otp}});
    // //params
    const response = await fetcherGET(
      `${endpoints.collection.getPatient}${args.id}`,
      {
        params: {
          otp: args?.otp,
          patientSessionToken: args?.patientSessionToken,
          withoutConsent: args?.withoutConsent, 
        },
      }
    );


    return response;
  } catch (error) {
    console.error('FetchPatient error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};




export const searchPatient = async (args = {}) => {
  try {
    const response = await fetcherGET(
      `${endpoints.collection.searchPatient}?searchText=${encodeURIComponent(args.searchText)}`
    );
    return response;
  } catch (error) {
    console.error('searchPatient error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const createCollection = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.collection.createCollection}`, args);
    return response;
  } catch (error) {
    console.error('createCollection error:', error);
    var response = {};
    response.status = false;

    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};

export const deleteCollection = async (args = {}) => {
  try {
    const response = await deleter(`${endpoints.collection.deleteCollection}${args.id}`);
    return response;
  } catch (error) {
    console.error('deleteCollection error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};


export const createPatient = async (args = {}) => {
  try {
    const response = await poster(`${endpoints.collection.createPatient}`, args);
    return response;
  } catch (error) {
    console.error('createPatient error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
};


// OTP flow for updating a patient profile
export const sendUpdatePatientOtp = async (patientId) => {
  try {
    const url = `${endpoints.collection.updatePatient}${patientId}`;
    const response = await patcher(url, {});
    return response;
  } catch (error) {
    console.error('sendUpdatePatientOtp error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;
  }
};

export const verifyUpdatePatientOtp = async (patientId, otp) => {
  try {
    const url = `${endpoints.collection.updatePatient}${patientId}?otp=${otp}`;
    const response = await patcher(url, {});
    return response;
  } catch (error) {
    console.error('verifyUpdatePatientOtp error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;
  }
};

export const updatePatientWithSession = async (patientId, body = {}, patientSessionToken) => {
  try {
    const tokenParam = encodeURIComponent(patientSessionToken ?? '');
    const url = `${endpoints.collection.updatePatient}${patientId}?patientSessionToken=${tokenParam}`;
    const response = await patcher(url, body);
    return response;
  } catch (error) {
    console.error('updatePatientWithSession error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;
  }
};


export const addOtherReport = async (formData) => {
  try {
    const response = await posterForm(`${endpoints.registries.addRegistry}`, formData, 'POST');
    return response;
  } catch (error) {
    console.error('addOtherReport error:', error);
    var response = {};
    response.status = false;
    response.message = error?.response?.data?.message ?? error.message;
    return response;
  }
};


export const useFetchRegistry = (args = {}) => {
  const userId = args?.userId;
  // Short-circuit if ID is 0, null, undefined, or invalid
  const isIdValid = !!userId && userId !== 0;
  const URL = isIdValid ? `${endpoints.registries.viewRegistry}?userId=${userId}` : null;

  const { data, error, isValidating } = useSWR(URL, fetcherSwr, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  const isLoading = isIdValid && !data && !error;

  return useMemo(() => ({
    report: data?.reports || [],
    isLoading,
    error,
    isValidating,
  }), [data?.data, isLoading, error, isValidating]);
};